

















import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import 'katex/dist/katex.min.css'
import katex from 'katex'

@Component
export default class MathTextField extends Vue {
  private attachment: any | null = null
  private katexPosition: {
    left: number | string
    top: number | string
    width: number | string
    color: string
  } = {
    left: 0,
    top: 0,
    width: 0,
    color: 'rgba(0, 0, 0, 0.6)',
  }
  private textPosition: {
    height: number | string
  } = {
    height: 0,
  }
  private textObserver: any
  private katexObserver: any

  @Prop()
  keyboardName!: string

  @Prop()
  value!: string | null

  @Prop({ default: false })
  isTextField?: boolean

  @Prop({ default: false })
  readonly?: boolean

  @Ref() textfield!: HTMLInputElement
  @Ref() katexfield!: HTMLElement

  get contentKatex(): string {
    if (!this.value) {
      return ''
    } else {
      return katex.renderToString(this.value.replace(/\\placeholder\{?\}?/g, '⬚'), {
        throwOnError: false,
        displayMode: false,
      })
    }
  }

  private mounted() {
    // アタッチメント (WebIMEとやり取りするためのモジュール)を設定
    this.attachment = Vue.prototype.$webime.createTextFieldAttachment({
      keyboardName: this.keyboardName,
      singleLine: true,
    })

    // IMEによるテキスト内容変更時
    this.attachment.on('text-change', (evt: any) => {
      if (this.readonly) {
        evt.preventDefault(true)
        return
      }
      this.$emit('input', evt.text)
    })

    this.textObserver = new (window as any).ResizeObserver(() => {
      this.katexPosition = {
        width: `${this.textfield.offsetWidth - 4}px`,
        left: `${this.textfield.offsetLeft + 2}px`,
        top: `${this.textfield.offsetTop + 2}px`,
        color: 'rgb(0, 0, 0)',
      }
    })
    this.textObserver.observe(this.textfield)

    this.katexObserver = new (window as any).ResizeObserver(() => {
      this.textPosition = {
        height: `${(this.katexfield.offsetHeight > 41 ? this.katexfield.offsetHeight : 41) + 4}px`,
      }
    })
    this.katexObserver.observe(this.katexfield)
  }

  private beforeDestroy() {
    // アタッチメントを解放
    Vue.prototype.$webime.releaseTextFieldAttachment(this.attachment)
    this.attachment = null
    this.textObserver.disconnect()
    this.katexObserver.disconnect()
  }

  private onClick() {
    if (this.readonly) return
    this.textfield.focus()
    this.onFocus()
  }

  private onFocus() {
    // フォーカスを通知
    if (this.readonly) return
    this.attachment.focus()
    this.attachment.setLatex(this.value)
    this.textfield.classList.add('use-webime')
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    const rect = this.textfield.getBoundingClientRect()
    window.scrollTo({
      top: rect.top + window.pageYOffset + rect.height / 2 - vh / 2,
      behavior: 'smooth',
    })
  }
  private onBlur() {
    this.textfield.classList.remove('use-webime')
    this.attachment.blur()
  }
}
